import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map} from 'rxjs/operators';

const httpOptions = {
  headers : new HttpHeaders({
    'Content-Type': 'application/json'
  })
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  api_url = "https://blogcreatorapi.herokuapp.com/";
  constructor(private http : HttpClient, private _router : Router) { }

  login(username : string, password : string){
    return this.http.post<any>(this.api_url + 'accounts/api-auth/',{username, password}, httpOptions).
    pipe(map(user =>{
      if (user && user.token) {
        localStorage.setItem('token', user.token);
        this._router.navigate(['/blog']);
      }
      return user;
    }));
  }



  registerUser(register_data){
    this.http.post<any>(this.api_url + 'accounts/register/',register_data).subscribe(data=>{
      this._router.navigate(['/login'])
    })
  }

  logoutUser() {
    localStorage.removeItem('token')
    this._router.navigate(['/'])
  }

  getToken() {
    return localStorage.getItem('token')
  }

  loggedIn()  {
    var data = {"key":localStorage.getItem('token')};

    return this.http.post<any>(this.api_url + 'accounts/verify-token/',data);

  }

}
